import service from '@/utils/server'

const modName = '/tms/transportPlanNew/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

/**
 * 查询可预约列表
 * @param data
 * @returns {*}
 */
export const queryAppointmentTableData = data => {
  return service({
    url: modName + 'selectPendingSchOrderForPlan',
    method: 'post',
    data
  });
};

/**
 * 新增调度前置校验
 * @param data
 * @returns {*}
 */
export const planCreatePreCheck = data => {
  return service({
    url: modName + 'planCreatePreCheck',
    method: 'post',
    data
  });
};

//调度-新增保存
export const createScheduInfoSave= data => {
  return service({
    url: modName + 'planCreateSubmit',
    method: 'post',
    data
  });
};

//查询计划装载量
export const scheduleInfoPlanOnload= data => {
  return service({
    url: modName + 'scheduleInfoPlanOnload',
    method: 'post',
    data
  });
};

/**
 * 编辑-初始化
 * @param data
 * @returns {*}
 */
export const editPlanInitPage = data => {
  return service({
    url: modName + 'editPlanInitPage',
    method: 'post',
    data
  });
};

/**
 * 编辑-提交
 * @param data
 * @returns {*}
 */
export const editSubmit = data => {
  return service({
    url: modName + 'planEditSubmit',
    method: 'post',
    data
  });
};

/**
 * 编辑校验
 * @param data
 * @returns {*}
 */
export const planEditPreCheck = data => {
  return service({
    url: modName + 'planEditPreCheck',
    method: 'post',
    data
  });
};

/**
 * 重新计算汇总
 */
export const scheduTotalRefresh= data => {
  return service({
    url: modName + 'scheduTotalRefresh',
    method: 'post',
    data
  });
};

/**
 * 发运初始化
 * @param data
 * @returns {*}
 */
export const shipInit = data => {
  return service({
    url: modName + 'scheduDespatchValidateParam',
    method: 'post',
    data
  });
};

/**
 * 发运/送达日期校验
 * @param data
 * @returns {*}
 */
export const checkDispatchDeliverNeedConfirm = data => {
  return service({
    url: modName + 'checkDispatchDeliverNeedConfirm',
    method: 'post',
    data
  });
};

/**
 * 送达初始化
 * @param data
 * @returns {*}
 */
export const deliverInit = data => {
  return service({
    url: modName + 'scheduDeliverValidateParam',
    method: 'post',
    data
  });
};

/**
 * 发运提交
 * @param data
 * @returns {*}
 */
export const shipSubmit = data => {
  return service({
    url: modName + 'scheduDespatch',
    method: 'post',
    data
  });
};

/**
 * 送达提交（带GPS校验）
 * @param data
 * @returns {*}
 */
export const deliverSubmitWithCheck = data => {
  return service({
    url: modName + 'batchOneClickDeliveryWithCheck',
    method: 'post',
    data
  });
};

/**
 * 送达提交（强制送达，跳过GPS校验）
 * @param data
 * @returns {*}
 */
export const deliverSubmit = data => {
  return service({
    url: modName + 'scheduDeliver',
    method: 'post',
    data
  });
};

/**
 * 取消
 * @param data
 * @returns {*}
 */
export const cancelPlan = data => {
  return service({
    url: modName + 'cancelPlan',
    method: 'post',
    data
  });
};

/**
 * 导出
 * @param data
 * @returns {*}
 */
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'exportData',
    method: 'post',
    data
  });
};

//订单轨迹查询
export const orderTrajectory = data => {
  return service({
    url: modName + 'orderTrajectory',
    method: 'post',
    data
  });
};
//文件下载
export const fileDownLoad = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'file/' + data.fileCode,
    method: 'post',
    data
  });
};

//订单查询
export const schedulingJobBillList = data => {
  return service({
    url: modName + 'selectPendingSchOrderForPlan',
    method: 'post',
    data
  });
};

/**
 * 追加订单
 * @param data
 * @returns {*}
 */
export const appendAddSchOrder = data => {
  return service({
    url: modName + 'appendAddSchOrder',
    method: 'post',
    data
  });
};

/**
 * 上传附件
 * @param data
 * @returns {*}
 */
export const uploadFile = data => {
  let config={
    headers: {
      "Accept": '*/*',
      'Content-Type': 'multipart/form-data'
    }
  }
  return service({
    ...config,
    url: modName + 'uploadFile',
    method: 'post',
    data
  });
};

/**
 * 更改承运商初始化
 * @param data
 * @returns {*}
 */
export const updateCarrierInit = data => {
  return service({
    url: modName + 'updateCarrierValidateParam',
    method: 'post',
    data
  });
};

/**
 * 更改承运商提交
 * @param data
 * @returns {*}
 */
export const updateCarrierSubmit = data => {
  return service({
    url: modName + 'updateCarrier',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/transport/transportPlan/api/index.js